import React, {useEffect, useState} from 'react';
import {Pie} from "@ant-design/plots";
import {DatePicker} from "antd";
import dayjs from "dayjs";
import moment from "moment/moment";
import {API_PATH} from "../../components/const";
import axios from "axios";

const dateFormat = 'YYYY-MM-DD';


const {RangePicker} = DatePicker;


const VisitorTimePie = () => {
    const [time, setTime] = useState(new Date());
    const [data, setData] = useState([])

        const today = new Date(); // Gets today's date
        const yesterday = new Date(today); // Creates a new date object from today's date

        yesterday.setDate(yesterday.getDate() - 1); // Subtracts one day

        const year = yesterday.getFullYear(); // Gets the year of the date
        const month = ('0' + (yesterday.getMonth() + 1)).slice(-2); // Gets the month of the date and formats it as two digits
        const day = ('0' + yesterday.getDate()).slice(-2); // Gets the day of the month and formats it as two digits



    const getData = () => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/analytics/vist-duratoin?year="+time?.getFullYear()+"&month=" + Number(time?.getMonth() + 1) + "&day=" + time?.getDate()  , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setData([
                    {
                        type: "Менее 5 минут",
                        value: res?.data?.summary?.number_of_users_below_5_minutes
                    },
                    {
                        type: "10-15 минут",
                        value: res?.data?.summary?.number_of_users_between_5_and_15_minutes
                    },
                    {
                        type: "15-30 минут",
                        value: res?.data?.summary?.number_of_users_between_15_and_30_minutes
                    },
                    {
                        type: "30-45 минут",
                        value: res?.data?.summary?.number_of_users_between_30_and_45_minutes
                    },
                    {
                        type: "45-60 минут",
                        value: res?.data?.summary?.number_of_users_between_45_and_60_minutes
                    },

                    {
                        type: "Более 1 часа",
                        value: res?.data?.summary?.number_of_users_above_60_minutes
                    },

                ])
            })
    }


    // function onChange(date, dateString) {
    //     if (dateString[0] !== "" && dateString[1] !== "") {
    //         axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/analitics/visit/time/percentage/by/period?start_date_str=" + dateString[0] + "&end_date_str=" + dateString[1], {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
    //             .then(res => {
    //                 setData([
    //                     {
    //                         type: "Менее 5 минут",
    //                         value: res?.data?.summary?.number_of_users_below_5_minutes
    //                     },
    //                     {
    //                         type: "10-15 минут",
    //                         value: res?.data?.summary?.number_of_users_between_5_and_15_minutes
    //                     },
    //                     {
    //                         type: "15-30 минут",
    //                         value: res?.data?.summary?.number_of_users_between_15_and_30_minutes
    //                     },
    //                     {
    //                         type: "30-45 минут",
    //                         value: res?.data?.summary?.number_of_users_between_30_and_45_minutes
    //                     },
    //                     {
    //                         type: "45-60 минут",
    //                         value: res?.data?.summary?.number_of_users_between_45_and_60_minutes
    //                     },
    //
    //                     {
    //                         type: "Более 1 часа",
    //                         value: res?.data?.summary?.number_of_users_above_60_minutes
    //                     },
    //
    //                 ])
    //             })
    //
    //     } else {
    //         axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/analitics/visit/time/percentage/by/period?start_date_str=&start_date_str=" + time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + 1 + "&end_date_str=" + moment().endOf('month').format('YYYY-MM-DD') , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
    //             .then(res => {
    //                 setData([
    //                     {
    //                         type: "Менее 5 минут",
    //                         value: res?.data?.summary?.number_of_users_below_5_minutes
    //                     },
    //                     {
    //                         type: "10-15 минут",
    //                         value: res?.data?.summary?.number_of_users_between_5_and_15_minutes
    //                     },
    //                     {
    //                         type: "15-30 минут",
    //                         value: res?.data?.summary?.number_of_users_between_15_and_30_minutes
    //                     },
    //                     {
    //                         type: "30-45 минут",
    //                         value: res?.data?.summary?.number_of_users_between_30_and_45_minutes
    //                     },
    //                     {
    //                         type: "45-60 минут",
    //                         value: res?.data?.summary?.number_of_users_between_45_and_60_minutes
    //                     },
    //
    //                     {
    //                         type: "Более 1 часа",
    //                         value: res?.data?.summary?.number_of_users_above_60_minutes
    //                     },
    //
    //                 ])
    //             })
    //     }
    // }

    const config = {
        appendPadding: 10,
        data,
        angleField: 'value',
        colorField: 'type',
        radius: 0.9,
        color: ['#FC53F5', '#5664D2', '#00E480', '#FF3542', '#0090EB', '#FFB100', '#4D4F6C'],
        label: {
            type: 'inner',
            offset: '-30%',
            content: ({percent}) => `${(percent * 100).toFixed(0)}%`,
            style: {
                fontSize: 14,
                textAlign: 'center',
            },
        },
        interactions: [
            {
                type: 'element-active',
            },
        ],
    };

    useEffect(() => {
        getData()
    }, []);

    return (
        <div className="visitor visitor-box" style={{paddingRight: "0"}}>
            <div className="chart-box ">

                <div className="visitor-title">
                    <h1><span>
                   Время посещения
                </span>
                        <span>

                           {/*<RangePicker*/}
                           {/*     placeholder={["Дата начала", "Дата окончания"]}*/}
                           {/*     defaultValue={[dayjs(moment().startOf('month').format('YYYY-MM-DD'), dateFormat), dayjs(moment().endOf('month').format('YYYY-MM-DD'), dateFormat)]}*/}
                           {/*     style={{width: "260px"}}*/}

                           {/*     format={dateFormat}*/}
                           {/*     onChange={onChange}*/}
                           {/* />*/}
                            {year  + "-" +  month + "-" + day}
                         </span>
                    </h1>
                </div>

                <Pie {...config} />
            </div>
        </div>
    );
};

export default VisitorTimePie;